import React, { Component } from 'react'
import LayoutComponent from './../layout'

export default (ComposedComponent) => {
  return class Layout extends Component {
    render() {
      return (
        <LayoutComponent>
          <ComposedComponent match={this.props.match} location={this.props.location} />
        </LayoutComponent>
      )
    }
  }
}
